<template>
    <div class="container">
        <a-spin tip="Emitindo..." :spinning="spinning">
            <a-card>
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined />
                            <a href="/docs/history"><span>Documentos</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>Emissão de Documentos</a-breadcrumb-item>
                    </a-breadcrumb>
                </template>

                <a-row style="padding: 5px" v-if="!props.matricula">
                    <a-col :span="4">
                        <strong>Inscrição imobiliária:</strong>
                    </a-col>
                    <a-col :span="12">
                        <a-space>
                            <a-input-number 
                                v-model:value="data.matricula" 
                                style="width: 350px" 
                                min="0" 
                                @change="loadDocs" 
                            />
                        </a-space>
                    </a-col>
                </a-row>

                <a-row style="padding: 5px">
                    <a-col :span="4">
                        <strong>Modelo de Emissão:</strong>
                    </a-col>
                    <a-col :span="12">
                        <a-space>
                            <a-select 
                                v-model:value="data.doc" 
                                placeholder="Selecione" 
                                style="width: 350px" 
                                :options="options" 
                                @change="changeEmitModel"
                            >
                            </a-select>
                        </a-space>
                    </a-col>
                </a-row>

                <a-row v-if="temDivergencia" style="padding: 5px">
                    <a-col :span="16" :offset="4">
                        <a-alert
                            message="Aviso: Divergência de Logradouro"
                            description="Os nomes das ruas no cadastro administrativo diferem da base cartográfica (mapa)."
                            type="warning"
                            show-icon
                        />
                    </a-col>
                </a-row>

                <div>
                    <a-row v-if="data.doc?.custom_configs.length !== 0" v-for="(item, key) in data.doc?.custom_configs" :key="key" style="padding: 5px">
                        <a-col :span="4">
                            <strong>{{ item.description }}</strong>
                        </a-col>
                        <a-col :span="12">
                            <a-space>
                                <a-date-picker 
                                    v-if="item.data_type === 'timestamp'" 
                                    style="width: 350px" 
                                    v-model:value="item.value" 
                                    :locale="locale" 
                                    format="DD/MM/YYYY" 
                                />
                                <a-input 
                                    v-else 
                                    v-model:value="item.value" 
                                    style="width: 350px" 
                                    :type="item.data_type === 'varchar' ? 'text': 'number'" 
                                    placeholder="Valor da Variável" 
                                />
                            </a-space>
                        </a-col>
                    </a-row>
                </div>

                <a-row style="padding: 5px">
                    <a-col :span="4">
                        <strong>Processo:</strong>
                    </a-col>
                    <a-col :span="12">
                        <a-space>
                            <a-input 
                                v-model:value="data.processo" 
                                style="width: 350px" 
                                placeholder="Número do processo" 
                            />
                        </a-space>
                    </a-col>
                </a-row>

                <a-row style="padding: 5px">
                    <a-radio-group v-model:value="data.extension">
                        <a-radio value="pdf">PDF</a-radio>
                        <a-radio value="docx">DOCX</a-radio>
                    </a-radio-group>
                </a-row>
                <br />
                
                <a-row>
                    <a-col>
                        <a-button 
                            type="primary" 
                            @click="handleEmitClick" 
                            :disabled="spinning"
                        >
                            Emitir
                        </a-button>
                    </a-col>
                </a-row>
            </a-card>

            <a-card size="small" class="w-100 my-4 center-flex card-blue" title="Documentos emitidos" v-if="data.matricula" />

            <a-card v-for="certidao in docsEmitidos" :key="certidao.id || certidao.numero_certidao" v-if="docsEmitidos.length !== 0 && data.matricula" size="small" class="w-100 my-3">
                <template #extra>
                    <span style="color:grey">nº {{certidao.numero_certidao }}</span>
                </template>
                <div style="position:absolute; display:flex; gap:5px; right:10px; z-index:1">
                    <a-tooltip title="PDF" mouse-leave-delay="0">
                        <a-button type="primary" danger shape="circle" class="center-flex"
                                  @click="open(certidao, 'pdf')" :icon="h(FilePdfOutlined)" />
                    </a-tooltip>
                    <a-tooltip title="DOCX" mouse-leave-delay="0">
                        <a-button type="primary" shape="circle" class="center-flex"
                                  @click="open(certidao, 'docx')" :icon="h(FileWordOutlined)" />
                    </a-tooltip>
                </div>

                <template #title>
                    <span v-if="certidao.tipo === 'valorVenal'">Certidão de Valor Venal</span>
                    <span v-else-if="certidao.tipo === 'localizacao'">Certidão de Localização</span>
                    <span v-else-if="certidao.tipo === 'valorVenalFracao'">Certidão de Valor Venal - Fração Ideal</span>
                    <span v-else-if="certidao.tipo === 'lancamento'">Certidão de Lançamento</span>
                    <span v-else-if="certidao.tipo === 'confrontacoes'">Certidão de Confrontações</span>
                    <span v-else-if="certidao.tipo === 'demolicao'">Certidão de Demolição</span>
                    <span v-else-if="certidao.tipo === 'notificacao'">Notificação</span>
                    <span v-else>{{ certidao.tipo }}</span>
                </template>

                <div style="position:relative">
                    Data: {{ certidao.data }} <br />
                    Processo nº {{ certidao.processo }} <br />
                    Exercício da certidão: {{ certidao.exercicio_certidao }} <br />
                    <span v-if="certidao.tipo === 'valorVenal' || certidao.tipo === 'valorVenalFracao'">
                        Exercício venal: {{ certidao.exercicio_venal }}
                    </span>
                    <span v-else>
                        Observação: {{ certidao.observacao ?? '-' }}
                    </span>
                </div>
            </a-card>

            <a-empty v-else-if="data.matricula" description="Não há certidões emitidas para este lote" />
        </a-spin>

        <a-modal
            v-model:open="modalInconsistenciaVisivel"
            title="Divergência Encontrada"
            @cancel="fecharModal"
        >
            <p>Os nomes das ruas no cadastro administrativo diferem da base cartográfica (mapa).</p>
            <p>Deseja continuar com a emissão mesmo assim?</p>
            
            <template #footer>
                <a-button key="back" @click="fecharModal">OK</a-button>
                <a-button key="submit" type="primary" danger :loading="spinning" @click="emitirComInconsistencia">
                    Gerar o documento com a inconsistência
                </a-button>
            </template>
        </a-modal>

    </div>
</template>

<script setup>
import { ref, onMounted, h, computed } from "vue";
import { FileOutlined, FilePdfOutlined, FileWordOutlined } from '@ant-design/icons-vue';
import { notification } from 'ant-design-vue';
import locale from 'ant-design-vue/es/date-picker/locale/pt_BR'
import { openNotification } from "../../../utils/utilities";

const props = defineProps(["matricula"]);

const spinning = ref(false);
const docsEmitidos = ref([]);
const dadosConfrontacoes = ref([]); 

const modalInconsistenciaVisivel = ref(false);

const data = ref({
    doc: null,
    processo: null,
    matricula: props.matricula,
    extension: 'pdf',
   
    ignorar_divergencia: false 
});

const routes = {
    emitir: '/docs/emitir',
    documentos: '/api/docs',
    emitidos: '/docs/emitidos/', 
}

const options = ref([]);

const temDivergencia = computed(() => {
    if (!data.value.doc) return false;

    const nomeDoc = data.value.doc.label ? data.value.doc.label.toLowerCase() : '';
    const ehCertidaoConfrontacao = nomeDoc.includes('confrontações') || nomeDoc.includes('confrontacoes');

    if (!ehCertidaoConfrontacao) return false;

    if (!dadosConfrontacoes.value || dadosConfrontacoes.value.length === 0) return false;

    return dadosConfrontacoes.value.some(rua => rua.validado === false);
});

const changeEmitModel = () => {
    let opt = options.value.find(opt => opt.value === data.value.doc);
    data.value.doc = opt;
}

const loadDocs = async () => {
    if (!data.value.matricula) return;
    
    try {
        const response = await window.axios.get(routes.emitidos + data.value.matricula);
        
        if (response.data && response.data.data) {
            docsEmitidos.value = response.data.data.certidoes || [];
            dadosConfrontacoes.value = response.data.data.confrontacoes || [];
        } else {
            docsEmitidos.value = []; 
            dadosConfrontacoes.value = [];
        }

    } catch (error) {
        console.error("Erro ao carregar dados:", error);
        docsEmitidos.value = [];
        dadosConfrontacoes.value = [];
    }
}

const handleEmitClick = () => {
    if (!data.value.doc) {
        openNotification('warning', 'Selecione um modelo de emissão.');
        return;
    }

    if (temDivergencia.value) {
       
        modalInconsistenciaVisivel.value = true;
    } else {
     
        executarEmissao();
    }
}

const fecharModal = () => {
    modalInconsistenciaVisivel.value = false;
};

const emitirComInconsistencia = () => {
    data.value.ignorar_divergencia = true; 
    executarEmissao();
    fecharModal();
};

const executarEmissao = async () => {
    spinning.value = true;
    try {
        const response = await window.axios.post(routes.emitir, data.value);
        spinning.value = false;
        openNotification('success', response.data.message);
        
        if (response.data.data && response.data.data.file) {
            window.open(response.data.data.file);
        }
        
        await loadDocs();
        
        data.value.ignorar_divergencia = false;
        
        await loadDocs(); 
    } catch (error) {
        spinning.value = false;
        handleError(error);
    }
}

const handleError = (error) => {
    if (error.response) {
        const { data, status } = error.response;

        if (data.errors) {
            Object.keys(data.errors).forEach((field) => {
                openNotification('error', `${field}: ${data.errors[field].join(', ')}`);
            });
        }
        else if (data.message && typeof data.message === 'object') {
            Object.keys(data.message).forEach((field) => {
                openNotification('error', `${field}: ${data.message[field].join(', ')}`);
            });
        }
        else if (data.message) {
            openNotification('error', data.message);
        }
        else {
            openNotification('error', `Erro ${status}: Ocorreu um problema ao processar a solicitação.`);
        }
    } else if (error.request) {
        openNotification('error', 'Erro de conexão: O servidor não respondeu.');
    } else {
        openNotification('error', 'Ocorreu um erro inesperado.');
    }
}

const open = (record, extension) => {
    let path = extension === 'pdf' ? record.path : record.path.replace('pdf', 'docx');
    window.open(path);
}

onMounted(async () => {
    try {
        const docResponse = await window.axios.get(routes.documentos);
        const documentos = docResponse.data.data || docResponse.data; 

        if (Array.isArray(documentos)) {
            documentos.forEach((documento) => {
                options.value.push({
                    label: documento.name,
                    value: documento.id,
                    custom_configs: documento.custom_configs ? documento.custom_configs.map(config => ({ ...config, value: '' })) : []
                });
            });
        }

        if (data.value.matricula) {
            await loadDocs();
        }
    } catch (e) {
        console.error("Erro no onMounted", e);
    }
});
</script>

<style scoped>
.center-flex {
    display: flex;
    justify-content: center;
    align-items: center;
}
.card-blue {
    background-color: #e6f7ff;
    border-color: #1890ff;
}
</style>
